import React from 'react'

import {noop} from 'es-toolkit'

import cn from '../../libs/class-names'

import {CommonProps, Overwrite} from '../../types'

import Icon from '../icon'

type Props<T extends React.ElementType> = Overwrite<
  CommonProps<T>,
  {
    as?: T
    onClick?: React.MouseEventHandler
    children: React.ReactNode
    icon: React.ComponentProps<typeof Icon>['source']
    target?: string
  }
>

const ContactOptionButton = <T extends React.ElementType = 'button'>({
  as,
  className,
  children,
  icon,
  target = '_blank',
  onClick = noop,
  ...props
}: Props<T>) => {
  const Root = (as ?? 'button') as React.ElementType

  return (
    <Root
      type={Root === 'button' ? 'button' : undefined}
      target={Root === 'a' ? target : undefined}
      {...props}
      className={cn('ContactOptionButton', {}, className)}
      onClick={onClick}
    >
      <Icon source={icon} />
      <div className="ContactOptionButton__label">{children}</div>
    </Root>
  )
}

export default ContactOptionButton
